import { ErrorInfo } from 'react';

interface ErrorReport {
  error: Error;
  errorInfo?: ErrorInfo;
  context?: Record<string, unknown>;
}

function report({ error, errorInfo, context }: ErrorReport): void {
  if (import.meta.env.PROD) {
    // Production: structured payload — swap this console.error for Sentry.captureException
    const payload = {
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo?.componentStack,
      url: window.location.href,
      timestamp: new Date().toISOString(),
      ...context,
    };
    console.error('[ErrorReporting]', JSON.stringify(payload));
  } else {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }
}

export const errorReporting = { report };
